<template>
	<div id="tu-information-rate">
		<el-dialog
	    v-model="dialogVisible"
	    title="设置每小时的收费标准"
	    width="38%"
	    :before-close="handleClose"
	  >
	  	<p class="p">
	  		你需要设置你的时薪。我们向学生收取的课时费，还包括用于支付第三方提款的手续费、汇率波动的影响以及国际转账手续费等小额费用，这些都将叠加在您的时薪之上。课时费将显示在您的个人档案页面上。请在<a href="#" target="_blank">此处</a>阅读我们关于如何设定有竞争力的时薪的建议。
	  	</p>
	  	<p class="p">
	  		我们平台的服务费将从您的时薪中扣除，并随着您在我们这里授课的总课时数的增加而减少。请在下面输入您的时薪，查看您的最终收入。您的最终收入是固定的，不受汇率波动，国际转账等影响。
	  	</p>
	    <el-input v-model="content" placeholder="Enter your hourly rate" size="large" type="number">
			<template #prepend>{{ profile.currency || '' }}</template>
		</el-input>
		<div style="margin-top: 5px;">您的时薪必须至少为 {{ profile.currency }}{{ profile.currency_value != 1 ? '16' : '200' }}</div>
		<h4 style="font-size: 22px;">你的收入</h4>
		<el-row :gutter="20">
			<el-col :span="10" style="display: flex;align-items: center;">
				完成 1-249 个小时
			</el-col>
			<el-col :span="14">
				<el-input :value="content > 0 ? (content*0.75).toFixed(2) : 0.00" size="large" :readonly="true">
					<template #prepend>{{ profile.currency || '' }}</template>
				</el-input>
			</el-col>
		</el-row>
		<el-row :gutter="20" style="margin-top: 10px;">
			<el-col :span="10" style="display: flex;align-items: center;">
				完成 250+ 个小时
			</el-col>
			<el-col :span="14">
				<el-input :value="content > 0 ? (content*0.8).toFixed(2) : 0.00" :readonly="true" size="large">
					<template #prepend>{{ profile.currency || '' }}</template>
				</el-input>
			</el-col>
		</el-row>
	    <template #footer>
	      <span class="dialog-footer">
	        <el-button @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
	        <el-button type="primary" @click="handleSaveOperation">{{ $t('Save') }}</el-button>
	      </span>
	    </template>
	  </el-dialog>
	</div>
</template>
<script>
import TeacherApi from '@/api/teacher'

export default {
	name: "tu-information-rate",
	props: {
		profile: {
			type: Object,
			default: function() {
				return {}
			}
		}
	},
	components: {
		
	},
	data() {
		return {
			dialogVisible: false,
			content: 0
		}
	},
	watch: {
		profile() {
			this.content = this.profile.rate || 0
		}
	},
	created() {
		
	},
	methods: {
		open() {
			this.dialogVisible = true;
		},
		handleSaveOperation() {
			let content = parseFloat(this.content);
			let fee = this.profile.currency_value != 1 ? 16 : 200;
			if(content < fee) {
				this.$message.error("您的时薪必须至少为" + this.profile.currency + '' + fee);
				return ;
			}
			let params = {
				rate: content
			}
			TeacherApi.store(params).then(res => {
				this.$emit('change', {name: 'rate', content: content});
				this.$message.success(this.$t('Save Success'));
				this.dialogVisible = false;
			})
		}
	}
}
</script>
<style lang="less">
#tu-information-rate {
	.el-dialog {
		.el-dialog__body {
			padding-top: 5px;
		}
	}
	.el-input {
		.el-input-group__prepend {
			font-weight: 800;
			font-size: 20px;
		}
	}
	.p {
		line-height: 1.5;
	}

	.el-dialog__footer {
		text-align: center;
	}
}
</style>